import { render, staticRenderFns } from "./customer-person-info.vue?vue&type=template&id=675c221c&"
import script from "./customer-person-info.vue?vue&type=script&lang=js&"
export * from "./customer-person-info.vue?vue&type=script&lang=js&"
import style0 from "./customer-person-info.vue?vue&type=style&index=0&id=675c221c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports